import subMinutes from "date-fns/subMinutes"
import subHours from "date-fns/subHours"
import subDays from "date-fns/subDays"
import subWeeks from "date-fns/subWeeks"
import addMinutes from "date-fns/addMinutes"
import addHours from "date-fns/addHours"
import addDays from "date-fns/addDays"
import addWeeks from "date-fns/addWeeks"
import { ReminderTimeDetails } from "../api/reminder-response"

export function calculateAbsoluteReminderTime(details: ReminderTimeDetails): Date {
  const base = details.refDate
  const { value, unit, isAfter } = details

  switch (unit) {
    case "minutes":
      return isAfter ? addMinutes(base, value) : subMinutes(base, value)
    case "hours":
      return isAfter ? addHours(base, value) : subHours(base, value)
    case "days":
      return isAfter ? addDays(base, value) : subDays(base, value)
    case "weeks":
      return isAfter ? addWeeks(base, value) : subWeeks(base, value)
    default:
      return base
  }
}
